var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0000915527,
    width: 30,
    height: 30,
    rx: 7,
    fill: "#F61C0D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 18.2025C6 16.3033 6 14.4077 6 12.5085C6.03171 12.3182 6.04933 12.128 6.09513 11.9412C6.5109 10.1654 7.97315 9.00264 9.79831 9.00264C13.2689 8.99912 16.7396 8.99912 20.2067 9.00264C20.4921 9.00264 20.7845 9.02378 21.0594 9.09073C22.8211 9.49945 23.9838 10.9582 23.9944 12.7657C24.005 14.4922 23.9979 16.2223 23.9944 17.9488C23.9944 18.6147 23.8464 19.2524 23.5011 19.8268C22.7506 21.0741 21.6407 21.7083 20.1855 21.7118C16.729 21.7189 13.2689 21.7154 9.81241 21.7154C9.73489 21.7154 9.6609 21.7154 9.58338 21.7118C8.0859 21.6555 6.74345 20.69 6.24312 19.2736C6.12685 18.9283 6.08104 18.5583 6 18.2025ZM12.5255 15.3379C12.5255 16.1095 12.5255 16.8847 12.5255 17.6563C12.5255 17.9734 12.6418 18.0474 12.9272 17.9135C14.4951 17.1665 16.0631 16.4196 17.631 15.6655C17.7191 15.6233 17.8424 15.514 17.8354 15.4436C17.8283 15.3555 17.7226 15.2463 17.631 15.2004C16.0631 14.3971 14.4916 13.6043 12.9201 12.8115C12.6488 12.6741 12.5255 12.7516 12.5255 13.0546C12.5255 13.8157 12.5255 14.5768 12.5255 15.3379Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5256 15.3379C12.5256 14.5768 12.5256 13.8157 12.5256 13.0546C12.5256 12.7516 12.6489 12.6741 12.9202 12.8115C14.4917 13.6078 16.0631 14.4006 17.6311 15.2004C17.7227 15.2462 17.8284 15.3555 17.8355 15.4436C17.8425 15.514 17.7192 15.6233 17.6311 15.6655C16.0667 16.4196 14.4987 17.1665 12.9273 17.9135C12.6418 18.0474 12.5256 17.9734 12.5256 17.6563C12.5256 16.8847 12.5256 16.1095 12.5256 15.3379Z",
    fill: "#F61C0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.91729bdd20a19f2fe30408e53fcf78bf.svg";
export { ForwardRef as ReactComponent };